import { store } from '../../index';
import actionTypes from './actionTypes';

export const setInfoFields = (infoFieldsArray) => ({
  type: actionTypes.setInfoFields,
  value: infoFieldsArray.filter((infoField) => {
    return infoField.name !== 'Reviewed';
  }),
});
